import React from 'react';
import './Footer.css';
import { Button } from './Button';
import { Link } from 'react-router-dom';

function Footer() {
  return (
    <div className='footer-container'>
      <section className='footer-subscription'>
        <p className='footer-subscription-heading'>
          Join the PapisPepper newsletter to receive updates on our newest releases.
        </p>
        <p className='footer-subscription-text'>
          You can unsubscribe at any time.
        </p>
        <div className='input-areas'>
          <form>
            <input
              className='footer-input'
              name='email'
              type='email'
              placeholder='Your Email'
            />
            <Button className='subscribe-button' buttonStyle='btn--outline'>Subscribe</Button>
          </form>
        </div>
      </section>
      <div class='footer-links'>
        <div className='footer-link-wrapper'>
          <div class='footer-link-items'>
            <h2>About Us</h2>
            <Link to='/coming-soon'>How it works</Link>
            <Link to='/coming-soon'>Testimonials</Link>
            <Link to='/coming-soon'>Careers</Link>
            <Link to='/coming-soon'>Investors</Link>
            <Link to='/coming-soon'>Terms of Service</Link>
          </div>
          <div class='footer-link-items'>
            <h2>Contact Us</h2>
            <Link to='/coming-soon'>Contact</Link>
            <Link to='/coming-soon'>Support</Link>
            <Link to='/coming-soon'>Destinations</Link>
            <Link to='/coming-soon'>Sponsorships</Link>
          </div>
        </div>
        <div className='footer-link-wrapper'>
          <div class='footer-link-items'>
            <h2>Videos</h2>
            <Link to='/coming-soon'>Submit Video</Link>
            <Link to='/coming-soon'>Ambassadors</Link>
            <Link to='/coming-soon'>Agency</Link>
            <Link to='/coming-soon'>Influencer</Link>
          </div>
          <div class='footer-link-items'>
            <h2>Social Media</h2>
            <Link to='/coming-soon'>Instagram</Link>
            <Link to='/coming-soon'>Facebook</Link>
            <Link to='/coming-soon'>Youtube</Link>
            <Link to='/coming-soon'>Twitter</Link>
          </div>
        </div>
      </div>
      <section class='social-media'>
        <div class='social-media-wrap'>
          <div class='footer-logo'>
            {/* <Link to='/' className='social-logo'>
              TRVL
              <i class='fab fa-typo3' />
            </Link> */}
            <img src= '/images/papis_logo.png' alt="" width={120} />
          </div>
          <small class='website-rights'>PapisPeppers © 2024</small>
          <div class='social-icons'>
            <Link
              class='social-icon-link facebook'
              to='/coming-soon'
              target='_blank'
              aria-label='Facebook'
            >
              <i class='fab fa-facebook-f' />
            </Link>
            <Link
              class='social-icon-link instagram'
              to='/coming-soon'
              target='_blank'
              aria-label='Instagram'
            >
              <i class='fab fa-instagram' />
            </Link>
            <Link
              class='social-icon-link youtube'
              to='/coming-soon'
              target='_blank'
              aria-label='Youtube'
            >
              <i class='fab fa-youtube' />
            </Link>
            <Link
              class='social-icon-link twitter'
              to='/coming-soon'
              target='_blank'
              aria-label='Twitter'
            >
              <i class='fab fa-twitter' />
            </Link>
            <Link
              class='social-icon-link twitter'
              to='/coming-soon'
              target='_blank'
              aria-label='LinkedIn'
            >
              <i class='fab fa-linkedin' />
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
}

export default Footer;
